const ExternalLink = (props) => (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children ? props.children : props.text} <i className="fa fa-external-link"></i>
    </a>
  )

export default ExternalLink;
